
import React from "react";
import Layout from "@/components/Layout";

const Privacy = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-8 text-lawyer-primary">Política de Privacidade</h1>
          
          <div className="prose prose-lg max-w-none">
            <p>
              A LexPrompt valoriza sua privacidade e está comprometida em proteger seus dados pessoais. Esta Política de Privacidade explica como coletamos, usamos e protegemos suas informações.
            </p>

            <h2>1. Informações que Coletamos</h2>
            <p>
              1.1. <strong>Informações de cadastro:</strong> nome completo, endereço de e-mail, senha (armazenada de forma criptografada) e dados profissionais.
            </p>
            <p>
              1.2. <strong>Informações de uso:</strong> quais prompts você utiliza, frequência de uso e feedbacks sobre os prompts.
            </p>
            <p>
              1.3. <strong>Informações de pagamento:</strong> processadas por nosso parceiro Stripe, não armazenamos dados completos de cartão de crédito.
            </p>
            <p>
              1.4. <strong>Dados de navegação:</strong> endereço IP, tipo de navegador, páginas visitadas e tempo gasto na plataforma.
            </p>

            <h2>2. Como Utilizamos Suas Informações</h2>
            <p>
              2.1. Fornecer e melhorar nossos serviços, incluindo personalização da experiência do usuário.
            </p>
            <p>
              2.2. Processar pagamentos e gerenciar sua conta e assinatura.
            </p>
            <p>
              2.3. Comunicar-nos com você sobre atualizações, novos recursos ou informações relevantes.
            </p>
            <p>
              2.4. Analisar tendências de uso para melhorar nossa plataforma e desenvolver novos prompts.
            </p>
            <p>
              2.5. Cumprir obrigações legais e proteger nossos direitos.
            </p>

            <h2>3. Compartilhamento de Informações</h2>
            <p>
              3.1. <strong>Parceiros de serviço:</strong> compartilhamos dados com parceiros que nos ajudam a operar nossos serviços (como processadores de pagamento, hospedagem e análise).
            </p>
            <p>
              3.2. <strong>Requisitos legais:</strong> podemos divulgar informações quando exigido por lei ou para proteger nossos direitos.
            </p>
            <p>
              3.3. Não vendemos ou alugamos suas informações pessoais a terceiros para fins de marketing.
            </p>

            <h2>4. Segurança de Dados</h2>
            <p>
              4.1. Implementamos medidas técnicas e organizacionais para proteger suas informações contra acesso não autorizado, alteração ou destruição.
            </p>
            <p>
              4.2. Senhas são armazenadas em formato criptografado e as conexões com nosso site são protegidas por SSL.
            </p>

            <h2>5. Seus Direitos</h2>
            <p>
              5.1. <strong>Acesso:</strong> você pode solicitar acesso às suas informações pessoais que mantemos.
            </p>
            <p>
              5.2. <strong>Correção:</strong> você pode atualizar ou corrigir suas informações pela área do perfil de usuário.
            </p>
            <p>
              5.3. <strong>Exclusão:</strong> você pode solicitar a exclusão da sua conta e dados pessoais.
            </p>
            <p>
              5.4. <strong>Portabilidade:</strong> você pode solicitar uma cópia eletrônica dos seus dados.
            </p>
            <p>
              5.5. Para exercer esses direitos, entre em contato conosco através do e-mail contato@decidedigital.com.br.
            </p>

            <h2>6. Retenção de Dados</h2>
            <p>
              Mantemos seus dados pelo tempo necessário para fornecer nossos serviços, cumprir nossas obrigações legais ou resolver disputas. Após o encerramento da sua conta, podemos reter alguns dados por um período adicional para fins legais ou comerciais legítimos.
            </p>

            <h2>7. Cookies e Tecnologias Semelhantes</h2>
            <p>
              Utilizamos cookies e tecnologias semelhantes para melhorar a experiência do usuário, analisar o uso da plataforma e personalizar o conteúdo. Você pode controlar o uso de cookies através das configurações do seu navegador.
            </p>

            <h2>8. Alterações nesta Política</h2>
            <p>
              Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre mudanças significativas através de um aviso em nosso site ou por e-mail.
            </p>

            <h2>9. Contato</h2>
            <p>
              Se você tiver dúvidas sobre esta Política de Privacidade ou sobre como tratamos seus dados, entre em contato conosco pelo e-mail contato@decidedigital.com.br.
            </p>

            <p className="mt-8">
              Última atualização: 19 de maio de 2024
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Privacy;
